import { Popover, PopoverProps } from 'antd';
import { IconProps } from 'react-feather';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';

interface Props {
  redirect?: string;
  content?: string;
  disabled?: boolean;
  iconProps?: IconProps;
  popoverProps?: PopoverProps;
}

export default function WhatsAppIcon({
  content = 'WhatsApp',
  disabled = false,
  redirect,
  iconProps,
  popoverProps,
}: Props) {
  const icon = (
    <FaWhatsapp
      {...iconProps}
      size={20}
      cursor="pointer"
      onClick={!disabled ? iconProps?.onClick : undefined}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : undefined,
      }}
    />
  );

  return (
    <Popover content={content} {...popoverProps}>
      {redirect ? (
        <span
          style={{
            cursor: disabled ? 'not-allowed' : undefined,
          }}
        >
          <Link
            to={redirect}
            style={{
              pointerEvents: disabled ? 'none' : undefined,
            }}
          >
            {icon}
          </Link>
        </span>
      ) : (
        icon
      )}
    </Popover>
  );
}
